import { render, staticRenderFns } from "./UserVerify.vue?vue&type=template&id=c56ed1d6"
import script from "./UserVerify.vue?vue&type=script&lang=js"
export * from "./UserVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports